import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { DeleteIcon, NewBackButton } from "../../../../components/svgs";
import { StyledText } from "../../../../components/common";
import usePeerTalk from "../hooks/usePeerTalk";
import { useSubscriber } from "../../../../hooks";
import StoryForm from "../components/StoryForm";
import LoadingUI from "../components/LoadingUI";
import InappropriatePostModal from "../components/InappropriatePostModal";

const WriteStory = () => {
  const { loading, error, BASE_URL } = usePeerTalk();
  const history = useHistory();

  const [title, setTitle] = useState("");
  const [story, setStory] = useState("");
  const [category, setCategory] = useState("");
  const [coverImage, setCoverImage] = useState(null);
  const [coverFile, setCoverFile] = useState();
  const [errors, setErrors] = useState({});
  const [submissionError, setSubmissionError] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const { fetchUserProfile, userDetails } = useSubscriber();
  const [
    isInappropriatePostModalVisible,
    setIsInappropriatePostModalVisible
  ] = useState(false);

  useEffect(() => {
    fetchUserProfile();
  }, []);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file.size > 2 * 1024 * 1024) {
      setErrors((prev) => ({
        ...prev,
        coverImage: "Image size should be less than 2MB",
      }));
      return;
    }
    const imageUrl = URL.createObjectURL(file);
    setCoverFile(file);
    setCoverImage(imageUrl);
    setErrors((prev) => ({ ...prev, coverImage: "" }));
  };

  const removeImage = () => {
    setCoverImage(null);
  };

  const token = JSON.parse(localStorage.getItem("token"));

  const handleSubmit = async () => {
    if (isProcessing) return;
    const newErrors = {};
    if (!title) newErrors.title = "Title is required";
    if (!story) newErrors.story = "Story is required";
    if (!category) newErrors.category = "Category is required";
    if (!coverImage) newErrors.coverImage = "Cover image is required";
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    const payload = new FormData();
    payload.append("title", title);
    payload.append("story", story);
    payload.append("category", category);
    payload.append("authorId", userDetails?.msisdn);

    if (coverFile) {
      payload.append("coverImage", coverFile);
    }

    try {
      setIsProcessing(true);
      const response = await fetch(`${BASE_URL}/stories`, {
        method: "POST",
        headers: {
          "Authorization": `Token ${token}`
        },
        body: payload,
      });

      if (!response.ok) {
        if (response.status === 403) {
          setIsInappropriatePostModalVisible(true);
        }
        throw new Error("Failed to create story");
      }

      history.push("/peer_talk");
    } catch (error) {
      setSubmissionError(error.message);
    } finally {
      setIsProcessing(false);
    }
  };

  if (loading) return <LoadingUI />;
  if (error) return <p>Error: {error}</p>;

  return (
    <MainHolder>
      <Children>
        {
          isInappropriatePostModalVisible &&
          <InappropriatePostModal
            onBackDropClick={() => setIsInappropriatePostModalVisible(false)}
          />
        }

        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            position: "fixed",
            zIndex: 100,
            background: "#fff",
          }}
        >
          <BackButtonContainer onClick={() => history.push("/peer_talk")}>
            <NewBackButton />
          </BackButtonContainer>
          <StyledText>Share your story</StyledText>
          <div
            onClick={() => history.push("/peer_talk/")}
            style={{ zIndex: 100, marginRight: "15px" }}
          >
            <DeleteIcon fill="#ff0303" />
          </div>
        </div>
        <DescriptionBody>
          <StoryForm
            onSubmit={handleSubmit}
            title={title}
            story={story}
            category={category}
            coverImage={coverImage}
            errors={errors}
            submissionError={submissionError}
            setTitle={setTitle}
            setStory={setStory}
            setCategory={setCategory}
            handleImageUpload={handleImageUpload}
            removeImage={removeImage}
            actionType="write-story"
          />
        </DescriptionBody>
      </Children>
    </MainHolder>
  );
};

const MainHolder = styled.div`
  overflow: hidden;
  background-color: white;
  height: 700px;
  position: relative;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    padding-bottom: 5px;
    height: 100vh;
  }
`;

const Children = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 8px;
`;

const DescriptionBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 20px;
  margin-top: 24px;
  margin-bottom: 140px;
`;

export default WriteStory;
